var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import styled from "styled-components";
import { ContentAreaProvider } from "./contentAreaContext";
var ContentAreaStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"])));
var ContentArea = function (_a) {
    var id = _a.id, className = _a.className, style = _a.style, children = _a.children;
    var _b = __read(React.useState(null), 2), contentArea = _b[0], setContentArea = _b[1];
    return (React.createElement(ContentAreaStyle, { ref: setContentArea, id: id, className: className, style: style },
        React.createElement(ContentAreaProvider, { value: contentArea }, children)));
};
export default ContentArea;
var templateObject_1;
//# sourceMappingURL=ContentArea.js.map